import React from 'react';

import { DashboardPrintViewContext } from 'src/providers/DashboardPrintViewProvider';

export const useDashboardPrintView = () => {
  return React.use(DashboardPrintViewContext);
};
